var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiCalendarDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_8789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.445 12.188V6.854H5.812C5.35864 7.09567 4.92049 7.36484 4.5 7.66V8.355C4.875 8.098 5.469 7.735 5.758 7.578H5.77V12.188H6.445ZM7.633 10.883C7.68 11.523 8.227 12.289 9.336 12.289C10.594 12.289 11.336 11.223 11.336 9.418C11.336 7.484 10.555 6.75 9.383 6.75C8.457 6.75 7.586 7.422 7.586 8.559C7.586 9.719 8.41 10.329 9.262 10.329C10.008 10.329 10.492 9.953 10.645 9.539H10.672C10.668 10.855 10.211 11.703 9.367 11.703C8.703 11.703 8.359 11.253 8.317 10.883H7.633ZM10.586 8.566C10.586 9.262 10.027 9.746 9.402 9.746C8.801 9.746 8.258 9.363 8.258 8.546C8.258 7.723 8.84 7.336 9.426 7.336C10.059 7.336 10.586 7.734 10.586 8.566Z",
    fill: "#7C37B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0.5C3.63261 0.5 3.75979 0.552678 3.85355 0.646447C3.94732 0.740215 4 0.867392 4 1V1.5H12V1C12 0.867392 12.0527 0.740215 12.1464 0.646447C12.2402 0.552678 12.3674 0.5 12.5 0.5C12.6326 0.5 12.7598 0.552678 12.8536 0.646447C12.9473 0.740215 13 0.867392 13 1V1.5H14C14.5304 1.5 15.0391 1.71071 15.4142 2.08579C15.7893 2.46086 16 2.96957 16 3.5V14.5C16 15.0304 15.7893 15.5391 15.4142 15.9142C15.0391 16.2893 14.5304 16.5 14 16.5H2C1.46957 16.5 0.960859 16.2893 0.585786 15.9142C0.210714 15.5391 0 15.0304 0 14.5V3.5C0 2.96957 0.210714 2.46086 0.585786 2.08579C0.960859 1.71071 1.46957 1.5 2 1.5H3V1C3 0.867392 3.05268 0.740215 3.14645 0.646447C3.24021 0.552678 3.36739 0.5 3.5 0.5ZM1 4.5V14.5C1 14.7652 1.10536 15.0196 1.29289 15.2071C1.48043 15.3946 1.73478 15.5 2 15.5H14C14.2652 15.5 14.5196 15.3946 14.7071 15.2071C14.8946 15.0196 15 14.7652 15 14.5V4.5H1Z",
    fill: "#7C37B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_8789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiCalendarDate);
export default __webpack_public_path__ + "static/media/bi_calendar-date.4121bd8e32de44ae4c9a2deddc545904.svg";
export { ForwardRef as ReactComponent };